import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Practice Management & RCM", displayLines: ["Practice Management", "RCM"], href: "#rcm" },
  { label: "Credentialing", href: "#credentialing" },
  { label: "Licensing", href: "#licensing" },
  { label: "Bookkeeping", href: "#bookkeeping" },
  { label: "Contact", href: "#consultation" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className="relative w-full bg-white border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8 py-3 md:py-4 flex items-center justify-between gap-6">
        <a href="#top" data-testid="site-logo-link" className="flex items-center gap-2 sm:gap-3 md:gap-5 group min-w-0 shrink">
          <img
            src="/assets/logo.png"
            alt="MediElite Practice Solutions"
            className="h-16 sm:h-20 md:h-28 lg:h-36 xl:h-44 w-auto object-contain transition-transform group-hover:scale-[1.02] shrink-0"
            data-testid="site-logo"
          />
          <div className="flex flex-col leading-tight min-w-0" data-testid="brand-wordmark">
            <span className="font-display text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl text-[color:var(--brand-green-700)] whitespace-nowrap">
              MediElite
            </span>
            <span className="font-display text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl text-navy -mt-0.5 md:-mt-1 whitespace-nowrap">
              Practice
            </span>
            <span className="font-display text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl text-navy -mt-0.5 md:-mt-1 whitespace-nowrap">
              Solutions
            </span>
            <span className="mt-1 text-[9px] sm:text-[10px] md:text-[11px] uppercase tracking-[0.18em] md:tracking-[0.22em] font-bold text-[color:var(--brand-green-700)] whitespace-nowrap">
              Precision That Performs
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8 shrink-0">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm font-medium text-slate-700 hover:text-navy transition-colors leading-tight text-center relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[color:var(--brand-green-400)] hover:after:w-full after:transition-all"
            >
              {n.displayLines ? (
                <span className="flex flex-col items-center">
                  {n.displayLines.map((line) => (
                    <span key={line}>{line}</span>
                  ))}
                </span>
              ) : (
                n.label
              )}
            </a>
          ))}
          <Button
            asChild
            data-testid="header-cta-book"
            className="rounded-xl md:rounded-2xl bg-navy text-white hover:bg-[color:var(--brand-navy-dark)] px-3 sm:px-4 md:px-5 py-2 h-auto leading-tight shrink-0 text-[11px] sm:text-xs md:text-sm"
          >
            <a href="#consultation" className="flex flex-col items-center text-center">
              <span>Book a Free</span>
              <span>Consultation</span>
            </a>
          </Button>
        </nav>

        <button
          type="button"
          data-testid="mobile-nav-toggle"
          className="lg:hidden p-2 rounded-md hover:bg-slate-100"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-nav-panel">
          <div className="px-5 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-slate-800 py-2 leading-tight"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.displayLines ? (
                  <span className="flex flex-col">
                    {n.displayLines.map((line) => (
                      <span key={line}>{line}</span>
                    ))}
                  </span>
                ) : (
                  n.label
                )}
              </a>
            ))}
            <Button
              asChild
              className="rounded-full bg-navy text-white mt-2"
              data-testid="mobile-header-cta-book"
            >
              <a href="#consultation" onClick={() => setOpen(false)}>
                Book a Free Consultation
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
